import "../jquery-ui.widget"
import videoHtml from './facebook-video.jquery.hbs'

$(function () {

  $.widget('hlq.fbVideo', {

    options: {
      template: videoHtml,
      autoRender: true
    },

    _create: function () {
      var self = this;
      var html;
      var $el;
      var url;
      var type;

      this.element.each(function () {
        $el = $(this);
        url = $el.data('fbVideo');
        type = (/video/.test(url)) ? 'video' : 'post';

        html = self.options.template({
          type: type,
          url: url,
          isVideo: type === 'video'
        });

        $el.html(html);

        if (self.options.autoRender) {
          self._render($el);
        }
      });
    },

    _render: function ($el) {
      window.FB.XFBML.parse($el[0]);
    }

  });
});
